<div
  [attr.aria-disabled]="detailsBlocked ? true : null"
  class="card card--project ion-activatable"
  [id]="'project-' + project.slug"
  *ngIf="project"
>
  <ion-ripple-effect></ion-ripple-effect>
  <div role="link" tabindex="0" (click)="openProject()">
    <div class="card__image">
      <img
        *ngIf="project.logoThumbnails"
        appImgFallback
        [src]="project.logoThumbnails.small"
        width="48"
        height="48"
        alt="{{ project.name }}"
      />
      <img
        *ngIf="!project.logoThumbnails"
        appImgFallback
        [src]="project.customer.logoThumbnails?.small"
        width="48"
        height="48"
        alt="{{ project.name }}"
      />
    </div>
    <div class="card__content">
      <ng-container *ngIf="withDistance">
        <span
          *ngIf="!loading && project.distance != null; else skeletonDistance"
        >
          {{ project.distance | distance }}
          <ng-container *ngIf="location != null; else locationNull">
            {{ 'search.project.from' | translate }} {{ location }}
          </ng-container>
          <ng-template #locationNull>
            {{ 'search.project.distance' | translate }}
          </ng-template>
        </span>
        <ng-template #skeletonDistance>
          <ngx-skeleton-loader
            [theme]="{
              height: 'calc(0.875rem * 1.25)',
              width: '100%',
              margin: '0',
              display: 'block'
            }"
          ></ngx-skeleton-loader>
        </ng-template>
      </ng-container>
      <h2>{{ project.name }}</h2>
      <span class="main" *ngIf="project.isParentProject">
        <span>{{ 'project.type.parent' | translate }}</span>
      </span>
      <span class="child" *ngIf="project.hasParentProject">
        <span inlineSVG="/assets/icons/reply.svg"></span>
        <span>{{
          'search.project.child'
            | translate : { project: project.parentProject.name }
        }}</span>
      </span>
      <span color="dark">
        {{ project.participants }}
      </span>
      <span>
        {{
          (project.amountOfFollowers == 1
            ? 'feed.followers.singular'
            : 'feed.followers.plural'
          ) | translate : { followers: project.amountOfFollowers }
        }}
      </span>
    </div>
  </div>
  <div
    *ngIf="!loading && project.starred != null; else skeletonFollow"
    class="card__follow ion-activatable"
    role="button"
    tabindex="0"
    [class.disabled]="disabled || pickingTarget"
    [class.following]="!disabled ? project.starred : false"
    (click)="toggleFollowProject($event)"
    [attr.aria-label]="
      project.starred
        ? ('project.unfollow' | translate)
        : ('project.follow' | translate)
    "
  >
    <ion-ripple-effect></ion-ripple-effect>
    <span [inlineSVG]="'/assets/icons/plus.svg'"></span>
    <span [inlineSVG]="'/assets/icons/check.svg'"></span>
    <app-loader
      name="dots"
      [loading]="true"
      *ngIf="disabled || pickingTarget"
    ></app-loader>
  </div>
  <ng-template #skeletonFollow>
    <ngx-skeleton-loader
      [theme]="{ height: '40px', width: '40px', margin: '0', display: 'block' }"
    ></ngx-skeleton-loader>
  </ng-template>
</div>
